import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminDataMigrationRuns = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/data_migration_runs/index/index.vue')
    createVueApp(IndexPage, { props })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/data_migration_runs/show/index.vue')
    createVueApp(ShowPage, { props })
  }
}
